<div class="container" *ngIf="prescriberDetails$ | async as details">
  <div class="loading-overlay" *ngIf="details.pending">
    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
  </div>

  <div class="container__form" [formGroup]="form">
    <div class="control-wrap">
      <kendo-formfield>
        <kendo-label [for]="ceIdInput" text="CE ID"> </kendo-label>
        <kendo-textbox #ceIdInput class="form-field" formControlName="ceId">
        </kendo-textbox>
      </kendo-formfield>
      <span *ngIf="ceId.invalid && ceId.dirty" class="validation-error">
        {{ getControlErrorMsg(ceId) }}
      </span>
    </div>

    <div class="control-wrap">
      <kendo-formfield>
        <kendo-label [for]="parentCEIdInput" text="Parent CE ID"> </kendo-label>
        <kendo-textbox
          #parentCEIdInput
          class="form-field"
          formControlName="parentCEId"
        >
        </kendo-textbox>
      </kendo-formfield>
      <span
        *ngIf="parentCEId.invalid && parentCEId.dirty"
        class="validation-error"
      >
        {{ getControlErrorMsg(parentCEId) }}
      </span>
    </div>

    <div class="control-wrap">
      <kendo-formfield>
        <kendo-label [for]="confidenceInput" text="Confidence"> </kendo-label>
        <kendo-dropdownlist
          #confidenceInput
          class="form-field"
          formControlName="confidence"
          [data]="confidenceOptions"
          [valuePrimitive]="true"
          textField="text"
          valueField="value"
        ></kendo-dropdownlist>
      </kendo-formfield>
      <span
        *ngIf="confidence.invalid && confidence.dirty"
        class="validation-error"
      >
        {{ getControlErrorMsg(confidence) }}
      </span>
    </div>

    <div class="control-wrap">
      <kendo-formfield>
        <kendo-label [for]="startDateInput" text="Start Date"> </kendo-label>
        <kendo-datepicker
          #startDateInput
          class="form-field"
          formControlName="startDate"
        >
        </kendo-datepicker>
      </kendo-formfield>
      <span
        *ngIf="startDate.invalid && startDate.dirty"
        class="validation-error"
      >
        {{ getControlErrorMsg(startDate) }}
      </span>
    </div>

    <div class="control-wrap">
      <kendo-formfield>
        <kendo-label [for]="endDateInput" text="End Date"> </kendo-label>
        <kendo-datepicker
          #endDateInput
          class="form-field"
          formControlName="endDate"
        >
        </kendo-datepicker>
      </kendo-formfield>
      <span *ngIf="endDate.invalid && endDate.dirty" class="validation-error">
        {{ getControlErrorMsg(endDate) }}
      </span>
    </div>
  </div>

  <kendo-dialog-actions class="container__toolbar">
    <div class="container__buttons">
      <button kendoButton class="container__button" (click)="close()">
        Cancel
      </button>
      <button
        kendoButton
        [primary]="true"
        class="container__button"
        (click)="save()"
        [disabled]="details.pending || !details.data || !npi"
      >
        Save
      </button>
    </div>
  </kendo-dialog-actions>
</div>
